import PageHeader from "@/components/PageHeader";
import Card from "@/components/Card";
import { Braces, CheckCircle2, Database, Info } from "lucide-react";

export default function SettingsPage() {
  return (
    <div data-testid="settings-page" className="max-w-[900px] mx-auto">
      <PageHeader title="Settings" subtitle="Manage your workspace and future integrations" />

      <Card title="Workspace" subtitle="Luna Accounting Studio salon operations" className="mb-4">
        <div className="grid sm:grid-cols-3 gap-3">
          {[
            ["Services", "Menu, pricing, duration and eligible team members"],
            ["Retail", "Products, stock, suppliers and purchase orders"],
            ["Finance", "Sales, payroll, expenses and profitability"],
          ].map(([title, text]) => (
            <div key={title} className="rounded-2xl bg-[#F5F5F7] border border-black/[0.05] p-4">
              <div className="flex items-center gap-2 text-[13px] font-semibold"><CheckCircle2 className="w-4 h-4 text-[#34C759]" /> {title}</div>
              <p className="mt-2 text-[11.5px] leading-relaxed text-[#6B6B73]">{text}</p>
            </div>
          ))}
        </div>
      </Card>

      <Card testid="crm-settings-card" title="CRM connection" subtitle="Connect this dashboard to your CRM app" className="mb-4">
        <div className="rounded-2xl border border-[#E879A8]/25 bg-[#F8EEF4] p-5">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-white border border-[#E879A8]/25 flex items-center justify-center flex-shrink-0">
              <Braces className="w-5 h-5 text-[#9D3D6C]" />
            </div>
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="font-display font-semibold text-[15px]">CRM app connection</h3>
                <span className="rounded-full bg-white border border-[#E879A8]/25 px-2 py-0.5 text-[10px] uppercase tracking-wider text-[#9D3D6C] font-semibold">Planned</span>
              </div>
              <p className="mt-1.5 text-[12.5px] leading-relaxed text-[#6B6B73]">
                When your CRM app is ready, this area can securely sync clients, bookings, service sales and retail transactions through its API.
              </p>
            </div>
          </div>
          <div className="mt-4 flex items-start gap-2 rounded-xl bg-white/75 border border-white px-3 py-2.5 text-[11.5px] text-[#6B6B73]">
            <Info className="w-3.5 h-3.5 mt-0.5 text-[#9D3D6C] flex-shrink-0" />
            No credentials or endpoint are required yet. All current data is managed directly in this workspace.
          </div>
        </div>
      </Card>

      <Card title="Live data" subtitle="Operational records stored in this workspace" className="mb-4">
        <div className="flex items-start gap-3 rounded-2xl bg-[#F5F5F7] border border-black/[0.05] p-4">
          <Database className="w-5 h-5 text-[#8E8E93] mt-0.5" />
          <div>
            <div className="font-medium text-[13px]">Live operational records</div>
            <p className="mt-1 text-[11.5px] text-[#6B6B73] leading-relaxed">
              New services, inventory, sales, payroll and expenses are treated as live business records. Manage them from their dedicated screens.
            </p>
          </div>
        </div>
      </Card>

    </div>
  );
}